import { get, isEmpty } from 'lodash';
import { INVERTED_LOCAL_METRIC_SWITCH_MAP } from '@utils/metrics';

function calcPercentage(total, value) {
  const pct = (value / total) * 100;
  return isNaN(pct) || !isFinite(pct) ? 'NA' : pct;
}

export function addLocalPercentageMetrics(metrics, rows, totals) {
  try {
    if (!isEmpty(rows) && !isEmpty(totals)) {
      metrics.forEach((metric) => {
        const localPctMetric = INVERTED_LOCAL_METRIC_SWITCH_MAP[metric];

        if (metric in INVERTED_LOCAL_METRIC_SWITCH_MAP && metric in totals) {
          rows.forEach((row) => {
            row[localPctMetric] = calcPercentage(totals[metric], row[metric]);
          });
          totals[localPctMetric] = 100;
        }
      });
    }
  } catch (err) {
    console.log('percentage calculation failed', err);
  }
}
